/**
 * Minimal system-api log client for runtime minLevel (request 0061).
 */

import { env } from '@/config/env'
import { authService } from '@/authService'

export type LogClientConfig = {
  minLevel: 'debug' | 'info'
  until?: string
}

async function logFetch<T>(path: string, orgId: string): Promise<T> {
  const host = env.systemApiUrl?.replace(/\/$/, '')
  if (!host) throw new Error('VITE_SYSTEM_API_URL is not configured')

  const token = await authService.getIdToken()
  if (!token) throw new Error('Sessão expirada — faça login novamente.')

  const res = await fetch(`${host}/log/v1${path}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      'X-Organization-Id': orgId,
      'X-Trace-Id': crypto.randomUUID(),
    },
  })

  const body = (await res.json().catch(() => ({}))) as {
    message?: string
    error?: string
  }

  if (!res.ok) {
    throw new Error(body.message || body.error || `HTTP ${res.status}`)
  }

  return body as T
}

export function fetchLogConfig(orgId: string): Promise<LogClientConfig> {
  return logFetch<LogClientConfig>('/config', orgId)
}
